function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import React from 'react';
import PropTypes from 'prop-types';
import defaultProps from '../default-props';
var UndrawWindowShopping = function UndrawWindowShopping(_props) {
  var props = Object.assign({}, _props);
  var primaryColor = props.primaryColor || defaultProps.primaryColor;
  var style = Object.assign({
    height: props.height || defaultProps.height,
    width: '100%'
  }, props.style);
  delete props.primaryColor;
  delete props.height;
  delete props.style;
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: "1em",
    height: "1em",
    viewBox: "0 0 708.76 778.88",
    style: style
  }, props), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "prefix__a",
    x1: 337.75,
    y1: 839.44,
    x2: 337.75,
    y2: 335.68,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  }))), React.createElement("path", {
    fill: "#ededf4",
    d: "M43.76 99.64h665v433.73h-665z"
  }), React.createElement("ellipse", {
    cx: 157.68,
    cy: 455.13,
    rx: 56.27,
    ry: 8.92,
    fill: "#3b477b"
  }), React.createElement("path", {
    fill: "#3b477b",
    d: "M148.76 128.46h17.84v326.67h-17.84z"
  }), React.createElement("circle", {
    cx: 157.68,
    cy: 137.38,
    r: 22.65,
    fill: "#3b477b"
  }), React.createElement("path", {
    d: "M207.78 157.97s-8.92 19.22-15.78 59l-39.12-43.21s10.51-4.24 21.67-9a84.69 84.69 0 0 1 33.23-6.79z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M207.78 157.97s-8.92 19.22-15.78 59l-39.12-43.21s10.51-4.24 21.67-9a84.69 84.69 0 0 1 33.23-6.79z",
    opacity: 0.08
  }), React.createElement("path", {
    d: "M108.96 157.97s12.35 36.37 13 50.78v17.16h72.06v-17.84a204.44 204.44 0 0 0-29.64-30.37 87.57 87.57 0 0 0-55.43-19.72z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M121.99 225.91s-18.53 22-19.9 48 11.67 103.63 11.67 103.63 43.92 15.78 87.84 0c0 0 13.73-79.61 12.35-105s-27.79-58.68-27.79-58.68z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M166.95 206.35s8.92-.69 14.41 2.06 12.7 3 12.7 3M166.95 210.44s8.92-.69 14.41 2.06 12.7 3 12.7 3M166.95 215.96s8.92-.69 14.41 2.06 12.7 3 12.7 3M125.77 226.26s-5.49 14.41-4.8 16.47-5.49 14.41-5.49 14.41M129.89 235.18s-5.49 14.41-4.8 16.47-5.49 14.41-5.49 14.41M191.65 226.26s5.49 14.41 4.8 16.47 5.49 14.41 5.49 14.41M187.53 235.18s5.49 14.41 4.8 16.47 5.49 14.41 5.49 14.41",
    opacity: 0.08
  }), React.createElement("ellipse", {
    cx: 372.48,
    cy: 498.36,
    rx: 56.27,
    ry: 8.92,
    fill: "#3b477b"
  }), React.createElement("path", {
    fill: "#3b477b",
    d: "M363.56 171.7h17.84v326.67h-17.84z"
  }), React.createElement("circle", {
    cx: 372.48,
    cy: 180.62,
    r: 22.65,
    fill: "#3b477b"
  }), React.createElement("path", {
    d: "M337.83 285.28l-81.67 113.23 22.65 8.93s-4.12 4.12-1.37 6.18c0 0 9.61 8.92 35 10.29 0 0 7.55-10.29 22.65 3.43s33.63 2.75 33.63 2.75 13.72-11.65 29.5-.65 35.69-5.49 35.69-5.49 10.29-15.1 32.25-9.61 22-15.1 22-15.1l-83-116.67z",
    fill: primaryColor
  }), React.createElement("g", {
    opacity: 0.08,
    fill: "#fff"
  }, React.createElement("path", {
    d: "M467.72 414.64c6 1.21 10.2.4 13.19-1.37a31.41 31.41 0 0 0-13.19 1.37zM298.02 413.61c-2.74-2.06 1.36-6.17 1.36-6.17l-22.65-8.92 61.08-113.24-81.65 113.23 22.65 8.93s-4.12 4.12-1.37 6.18c0 0 9.61 8.92 35 10.29a9.66 9.66 0 0 1 3.12-2.5c-12.47-3.11-17.54-7.8-17.54-7.8zM355.67 427.33c-15.1-13.73-22.65-3.43-22.65-3.43-.85 0-1.69-.1-2.5-.16a38.78 38.78 0 0 1 4.56 3.6c10.17 9.25 21.89 7.28 28.46 5a26.52 26.52 0 0 1-7.87-5.01zM418.81 429.44c-10-7-19.18-4.82-24.56-2.32a28.69 28.69 0 0 1 4 2.32c7.7 5.35 16.37 4.18 23.24 1.57a21.32 21.32 0 0 1-2.68-1.57z"
  })), React.createElement("path", {
    d: "M411.95 294.54h-76.87s-4.8-58.33-11.67-67.25a78.14 78.14 0 0 1 8.65-3.16 129.35 129.35 0 0 1 14-3.51 136.82 136.82 0 0 1 49.4-.45 132.35 132.35 0 0 1 14.14 3.3q5.54 1.61 11.24 3.82s-13.7 54.9-8.89 67.25z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M355.54 294.54h-10.22c-.13-12.91-9.59-54.65-13.26-70.42a129.35 129.35 0 0 1 14-3.51c.79 16.61 7.6 61.72 9.48 73.93zM409.63 223.44c-3.55 15.23-13.28 58-13.41 71.07H386c1.89-12.33 8.81-58.15 9.48-74.37a132.35 132.35 0 0 1 14.15 3.3z",
    fill: "#fff",
    opacity: 0.08
  }), React.createElement("ellipse", {
    cx: 585.92,
    cy: 457.19,
    rx: 56.27,
    ry: 8.92,
    fill: "#3b477b"
  }), React.createElement("path", {
    fill: "#3b477b",
    d: "M576.99 130.52h17.84v326.67h-17.84z"
  }), React.createElement("circle", {
    cx: 585.92,
    cy: 139.44,
    r: 22.65,
    fill: "#3b477b"
  }), React.createElement("path", {
    d: "M625.24 247.62c-.65-2.21-1.3-4.29-1.93-6.16v-25.5l8.24-35c-19.22-28.14-46 0-46 0-29.51-26.08-44.61 0-44.61 0 2.06 4.8 6.86 35 6.86 35v29c-10.92 22.87-14.19 48.29-12.69 73.76l5.14 87.37s49.41 19.22 90.59 0l4.12-73.26a251.3 251.3 0 0 0-9.72-85.21z",
    fill: primaryColor
  }), React.createElement("g", {
    opacity: 0.08
  }, React.createElement("path", {
    d: "M596.21 181.65s9.74-10.21 21.68-12.21c-10.88-3.52-21.67 3-27.51 7.56a66.56 66.56 0 0 1 5.83 4.65zM550.92 406.75l-5.14-87.37c-1.5-25.47 1.77-50.9 12.69-73.76v-29s-4.8-30.2-6.86-35c0 0 5.52-9.53 16.41-11.3-17.7-4.93-26.7 10.62-26.7 10.62 2.06 4.8 6.86 35 6.86 35v29c-10.92 22.87-14.19 48.29-12.69 73.76l5.14 87.37a150 150 0 0 0 45.05 8.48 148 148 0 0 1-34.76-7.8z"
  })), React.createElement("g", {
    opacity: 0.08
  }, React.createElement("path", {
    d: "M575.62 180.96a46.27 46.27 0 0 1 4.93-4.3c-10-7.18-18.14-8.18-24.35-6.7 5.57 1.22 12.04 4.48 19.42 11zM625.59 247.62c-.65-2.21-1.3-4.29-1.93-6.16v-25.5l8.24-35c-8.1-11.86-17.54-13.72-25.75-11.91 5.26 1.29 10.6 4.8 15.45 11.91l-8.24 35v25.48c.63 1.87 1.27 3.95 1.93 6.16a251.3 251.3 0 0 1 9.74 85.18l-4.12 73.26c-12 5.61-24.73 7.94-36.71 8.43 14.78.59 31.48-1.19 47-8.43l4.18-73.24a251.3 251.3 0 0 0-9.79-85.18z"
  })), React.createElement("path", {
    fill: "#ededf4",
    d: "M70.26 534h60v32h-60zM130.76 567.5h60v32h-60zM191.26 534h60v32h-60zM191.76 600.5h60v32h-60zM251.76 567.5h60v32h-60zM312.26 534h60v32h-60zM372.76 567.5h60v32h-60zM433.26 534h60v32h-60zM433.76 600.5h60v32h-60zM493.76 567.5h60v32h-60zM648.76 534.5h60v32h-60zM587.76 568.5h60v32h-60zM114.76 67.5h60v32h-60zM174.76 33.5h60v32h-60zM235.26 0h60v32h-60zM235.76 66.5h60v32h-60zM295.76 33.5h60v32h-60zM356.76 67.5h60v32h-60zM416.76 33.5h60v32h-60zM477.26 0h60v32h-60zM477.76 66.5h60v32h-60zM537.76 33.5h60v32h-60z"
  }), React.createElement("path", {
    fill: "#fff",
    opacity: 0.3,
    d: "M221.26 99.64L43.76 266.06v33.19l221.5-199.61h-44zM43.76 346.09v67l390-313.45-57.5-1.14-332.5 247.59z"
  }), React.createElement("path", {
    d: "M429.53 833l.08-.15.09-.19.06-.16a2.44 2.44 0 0 0 .06-.25v-.23-.19-.19-.17-.16c.18-1.44-.84-3.07-2.1-4.49a9.76 9.76 0 0 0-6.78-3.29c-14.4-.68-30.57-25.35-30.57-25.35l-.65.53a64.78 64.78 0 0 1-4.32-10.37h1.6v-.72l-2.22-23 6-68.87a61.77 61.77 0 0 0 4.15-12.88 22.8 22.8 0 0 0 .46-5v-.36a23.18 23.18 0 0 0-2.62-10.68l-25.17-48.49c.86.09 1.4.1 1.4.1 7.42-10.59 2.67-26.34-2.62-37.69 1.11-.6 1.86-1 1.86-1a3.62 3.62 0 0 1-.72-.38l.72-.35c-4.32-1.57-7.86-14-9.51-21l2.41-8.8a41.92 41.92 0 0 1 11.6 3.51s-.33-.68-.9-1.9l.85.42s-.33-.66-.88-1.85c-3.06-6.65-13.11-30-13.36-50.51a50.25 50.25 0 0 1 .72-8.15 40.65 40.65 0 0 0 .63-7.78 31.11 31.11 0 0 0-16.4-28.67s-9.76-8-12-17.5c-.74-3.12-3-5.68-5.76-7.72 1-7.47 4.78-14.4 8.61-19.73.43-.08.85-.16 1.27-.26q.74-1 1.45-1.84a26.36 26.36 0 0 0 19.21-25.12 26 26 0 0 0-11.54-21.5c.67-.08 1.42-.59 2.32-2a7.49 7.49 0 0 0 .37-6.64 12.07 12.07 0 0 0-3.05-4.07 31 31 0 0 0-6.69-4.81c-5.63-3.3-11.48-6.68-18-7.45a48.25 48.25 0 0 0-9.95.2l-15.1 1.35c-7.18.64-15.2 1.7-19.65 7.22s-3.78 13.59-8.25 19c-3.3 4-8.72 5.66-12.79 8.9-7.46 5.94-9.43 16.51-7.7 25.72s6.51 17.57 10.57 26.07 7.54 17.73 6.38 27c-1 8-5.35 15.32-6.9 23.26a34.25 34.25 0 0 0 1.21 17.63 7.38 7.38 0 0 0 1.72 3.11 4.37 4.37 0 0 0 .39.31 4.42 4.42 0 0 0 .36.42c1.48 1.4 3.74 1.58 5.81 1.64 5 .17 10.14.21 14.72 2.15a15.14 15.14 0 0 1 4.2 2.67 10 10 0 0 1 3.06 7.76c-.42 4.4-4.21 9-1.83 12.73h.39a5 5 0 0 0 .36.68 28.29 28.29 0 0 0 7.6.19 111.6 111.6 0 0 1 1 12.63c0 4.57-.62 8.44-2.06 10.72h.75a8.78 8.78 0 0 1-.75 1.52l2.95-.22a205.46 205.46 0 0 1-12.35 18.26 39 39 0 0 0-8.73 24.36 35.65 35.65 0 0 0 .14 3.91c.67 7.12 3.23 14.72 9.74 20.77 0 0 2.76 6.69 2.88 12.39a10.8 10.8 0 0 1-.63 3.65v51.75l-9 34.26a123.69 123.69 0 0 0-1.71 20.73c0 10 1.24 21.68 6.21 30.3l7.51 35.72.75.08v10c-.92-.8-1.5-1.36-1.5-1.36L287.16 835h.07l-.07.71s12.77 2.92 48.81 3.64h7.63l1.52-.07h.45l1-.06h.49l.93-.07h.43l1.11-.11h.16l1.19-.14h.33l.79-.12.37-.06.71-.12.33-.06.82-.17h.13l.89-.21.22-.06.61-.16.26-.08.53-.16.23-.07.59-.21h.1l.63-.26.13-.06.44-.21.16-.08.36-.2.14-.08.39-.24h.05l.4-.3h.05l.28-.25.08-.08.22-.23.06-.07.21-.27a3.17 3.17 0 0 0 .19-.32 2.78 2.78 0 0 0 .13-.29v-.06a2.55 2.55 0 0 0 .07-.26v-.06a2.46 2.46 0 0 0 0-.29 2.51 2.51 0 0 0 0-.55c.39-2.63-3.6-5.17-7.1-5.17-7.51 0-32.29-21.14-33.79-22.6-.63-.61-1.77-.42-3.18.27-1.12-1-2.37-2.28-3.58-3.64a3.2 3.2 0 0 0 .75-1.74l-.1-.25a3.14 3.14 0 0 0 .1-.48s-5.1-12.39-5.31-18.32a6.28 6.28 0 0 1 .05-.63l.61-52.32a34.1 34.1 0 0 1 6.25-19c3.1-4.47 6.29-11.39 6.66-21.23l10.41-37.93c13.95 12.9 25 30 26.26 31.9-.81 3.52-5.37 24.14-5.27 44.27v.36a92.71 92.71 0 0 0 1.64 18.26 187.28 187.28 0 0 1 4 36.54c0 4.14-.2 6.47-.2 6.47v.72h1.5v9.4l-.38-.29-9.39 16.4.2.19-.2.53s15.77 16 54.82 20.41l2.18.23.62.06 1.51.13h.58l1.89.14 1.72.09H421.71l1.12-.09h.17l.92-.11h.31l.65-.11.28-.05.8-.18h.12l.6-.18.23-.08.42-.16.21-.08.51-.25.11-.07.34-.21.16-.11.23-.18.13-.12a3.18 3.18 0 0 0 .25-.27l.1-.13z",
    transform: "translate(-245.62 -60.56)",
    fill: "url(#prefix__a)"
  }), React.createElement("path", {
    d: "M112.04 506.1s22.34 33.15 10.09 51.17c0 0-18 0-13.69-19.46A69.15 69.15 0 0 0 107 502.5zM47.18 733.84v25.94l23.06 2.16 8.65-13-2.16-3.6s-10.09-7.9-12.25-15.11-17.3 3.61-17.3 3.61z",
    fill: "#f7c4a7"
  }), React.createElement("path", {
    d: "M57.27 756.18s15.64-17.51 18.74-14.41c1.44 1.44 25.22 22.34 32.43 22.34s16.58 11.53-18 10.81-46.84-3.6-46.84-3.6l2.16-21.62s7.91 7.92 11.51 6.48z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M57.27 756.9s15.64-17.51 18.74-14.41c1.44 1.44 25.22 22.34 32.43 22.34s16.58 11.53-18 10.81-46.84-3.6-46.84-3.6l2.14-21.6s7.93 7.9 11.53 6.46z",
    fill: "#f3b5b7"
  }), React.createElement("path", {
    d: "M114.92 720.86v20.18l12.25 10.09 13.69-3.6 3.6-7.93s-7.21-10.09-9.37-27.39z",
    fill: "#f7c4a7"
  }), React.createElement("path", {
    d: "M125.01 742.44h8.65l9-7.57s15.52 24.39 29.33 25.06a9.27 9.27 0 0 1 6.5 3.26c3.61 4.18 5.27 10.31-20.34 7.36-37.46-4.28-52.59-20.11-52.59-20.11l9-16.22z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M125.01 743.2h8.65l9-7.57s15.52 24.39 29.33 25.06a9.27 9.27 0 0 1 6.5 3.26c3.61 4.18 5.27 10.31-20.34 7.36-37.48-4.32-52.61-20.18-52.61-20.18l9-16.22z",
    fill: "#f3b5b7"
  }), React.createElement("path", {
    d: "M111.32 493.85s4.32 23.06 10.09 25.22c0 0-12.25 5.77-10.09 11.53l-10.09-46.84 12.25 1.44z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M111.32 493.13s4.32 23.06 10.09 25.22c0 0-12.25 5.77-10.09 11.53l-10.09-46.84 12.25 1.4z",
    fill: "#fc6681"
  }), React.createElement("path", {
    d: "M111.32 493.13s4.32 23.06 10.09 25.22c0 0-12.25 5.77-10.09 11.53l-10.09-46.84 12.25 1.4zM101.95 520.52l43 85.31a23.39 23.39 0 0 1 2.07 15.1 62.4 62.4 0 0 1-4 12.74l-5.77 68.46 2.13 23.06h-25.9s1.44-18-3.6-43.24 3.6-62 3.6-62-15.85-25.94-33.87-38.92 22.34-60.51 22.34-60.51z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M101.95 519.79l43 85.31a23.39 23.39 0 0 1 2.07 15.1 62.4 62.4 0 0 1-4 12.74l-5.75 68.5 2.11 23h-25.9s1.44-18-3.6-43.24 3.6-62 3.6-62-15.85-25.94-33.87-38.92 22.34-60.49 22.34-60.49z",
    fill: "#575988"
  }), React.createElement("path", {
    d: "M101.95 520.16l43 85.31a23.39 23.39 0 0 1 2.07 15.1 62.4 62.4 0 0 1-4 12.74l-5.77 68.46 2.13 23.06h-25.9s1.44-18-3.6-43.24 3.6-62 3.6-62-15.85-25.94-33.87-38.92 22.34-60.51 22.34-60.51z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M55.83 482.32s-8.92 15.81-15.51 24.32a38.89 38.89 0 0 0-8.25 27.22c.64 7 3.1 14.55 9.35 20.53 0 0 4.32 10.81 2.16 16.58v51.17l-8.65 33.87s-5.77 31.71 4.32 49.73l7.21 35.31s23.06 2.88 23.78-4.32c0 0-5.77-14.41-5-19.46l.58-51.73a34.4 34.4 0 0 1 6-18.81c3-4.41 6-11.26 6.4-21l38.16-143.41z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M55.83 481.6s-8.92 15.81-15.51 24.32a38.89 38.89 0 0 0-8.25 27.22c.64 7 3.1 14.55 9.35 20.53 0 0 4.32 10.81 2.16 16.58v51.19l-8.65 33.87s-5.77 31.71 4.32 49.73l7.21 35.31s23.06 2.88 23.78-4.32c0 0-5.77-14.41-5-19.46l.58-51.73a34.4 34.4 0 0 1 6-18.81c3-4.41 6-11.26 6.4-21l38.16-143.43z",
    fill: "#575988"
  }), React.createElement("path", {
    d: "M107.72 534.21s5 32.43-13 42.52c0 0-7.21-5 2.88-21.62l.72-22.34z",
    fill: "#f7c4a7"
  }), React.createElement("path", {
    d: "M158.17 769.87c-34.06-3.93-49.66-17.38-52.22-19.8l-.39 1.06s15.13 15.85 52.61 20.18c19.17 2.21 23.06-.67 22.29-4-.72 2.63-5.97 4.44-22.29 2.56zM90.38 773.44c-32-.67-44.91-3.19-46.63-3.56l-.21 2.12s12.25 2.88 46.84 3.6c21.53.45 26-3.85 24.62-7.16-1.19 2.78-7.57 5.39-24.62 5zM46.82 554.75s17.3 0 22.34-4.32 17.3 0 17.3 0",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M42.5 706.09c-10.09-18-4.32-49.73-4.32-49.73l8.65-33.87v-51.17c2.16-5.77-2.16-16.58-2.16-16.58-6.25-6-8.71-13.49-9.35-20.53a38.89 38.89 0 0 1 8.25-27.22c6.59-8.51 15.51-24.32 15.51-24.32h57.46l.19-.72H56.19s-8.92 15.81-15.51 24.32a38.89 38.89 0 0 0-8.3 27.23c.64 7 3.1 14.55 9.35 20.53 0 0 4.32 10.81 2.16 16.58v51.17l-8.65 33.87s-5.77 31.71 4.32 49.73l7.21 35.31s1.09.14 2.79.27z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M97.63 340.35s-16.58 15.09-17.25 32.43-28.11-3.6-28.11-3.6 20.9-9.37 19.46-36.75z",
    fill: "#f7c4a7"
  }), React.createElement("path", {
    d: "M68.08 365.57s-22.34-8.65-26.67 28.11l5 48.29s8.65 36.75 2.88 46.12c0 0 59.1-5 76.39 4.32 0 0-17.3-36-13-61.26s-15.13-34.59-15.13-34.59-9.37-7.93-11.53-17.3-17.94-13.69-17.94-13.69z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M68.08 364.13s-22.34-8.69-26.7 28.1l4.12 39.44c.55 5.25 1.35 10.48 2.37 15.66 2.18 11.09 5.64 32.48 1.44 39.31 0 0 59.1-5 76.39 4.32 0 0-17.3-36-13-61.26s-15.13-34.59-15.13-34.59-9.37-7.93-11.53-17.3-17.96-13.68-17.96-13.68z",
    fill: "#fc6681"
  }), React.createElement("path", {
    d: "M63.76 411.69l25.94 95.85s10.09 23.06 5.77 29.55c0 0 11.53 5.77 16.58 0s-10.81-72.07-10.81-72.07l-9.37-53.33z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M64.48 410.97l25.9 95.85s10.09 23.06 5.77 29.55c0 0 11.53 5.77 16.58 0s-10.81-72.07-10.81-72.07l-9.37-53.33z",
    fill: "#fc6681"
  }), React.createElement("path", {
    d: "M92.22 427.19s7.21 20.9 10.81 23.06 1.44 18 1.44 18M71.32 342.15c3.93 2.4 7.67 9 12.61 9a26 26 0 0 0 6.11-.73 66.3 66.3 0 0 1 7.59-8.64l-25.94-7.93c.26 5.12.69 4.38-.37 8.3z",
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 83.94,
    cy: 323.77,
    r: 25.94,
    fill: "#f7c4a7"
  }), React.createElement("g", {
    opacity: 0.1
  }, React.createElement("path", {
    d: "M53.1 486.36c4-7.11.56-28.08-1.59-39-1-5.18-1.82-10.41-2.37-15.66l-4.12-39.44c2.7-22.93 12.41-28.19 19.33-28.9-6.55-.65-19.72 1.57-22.93 28.9l4.12 39.44c.55 5.25 1.35 10.48 2.37 15.66 2.18 11.09 5.64 32.48 1.44 39.31.03-.03 1.37-.14 3.75-.31zM84.66 485.29c16 .08 33 1.32 41.07 5.68 0 0-.31-.65-.84-1.83-9.76-3.15-25.78-3.92-40.23-3.85z"
  })), React.createElement("path", {
    d: "M92.62 317.74c-2.24 5.7-6.24 10.37-10.35 14.88-2.29 2.54-4.65 5.11-6 8.24a31.5 31.5 0 0 0-2 8.81c-1.6 12.35-3.09 25.51 2.31 36.72 1.51 3.14 3.54 6.06 4.54 9.39 1.82 6.1 0 12.67-2.42 18.58a109.52 109.52 0 0 1-12.78 23.2c-3 4.15-6.38 8.29-7.45 13.29-.72 3.35-.45 7.14-2.57 9.83-2.83 3.59-8.27 3.31-12.8 2.69-2.28-3.72 1.35-8.24 1.75-12.58.45-4.77-3.3-9.12-7.69-11s-9.34-2-14.13-2.12c-2-.07-4.15-.24-5.57-1.62a7.36 7.36 0 0 1-1.65-3.08 34.84 34.84 0 0 1-1.1-17.21c1.49-7.85 5.67-15.06 6.62-23 1.11-9.2-2.23-18.33-6.13-26.73s-8.49-16.66-10.15-25.77.23-19.55 7.39-25.43c3.91-3.21 9.1-4.86 12.27-8.8 4.29-5.33 3.71-13.37 7.92-18.76s12-6.5 18.85-7.14l14.49-1.33a45 45 0 0 1 9.55-.2c6.26.77 11.88 4.1 17.28 7.37 3.43 2.07 7.06 4.37 8.63 8.06a7.6 7.6 0 0 1-.36 6.56c-2.66 4.28-3.92.15-6 1.12-3.11 1.35-.78 11.73-2.45 16.03z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M91.9 317.02c-2.19 5.67-6.27 10.37-10.34 14.87-2.29 2.54-4.65 5.11-6 8.24a31.5 31.5 0 0 0-2 8.81c-1.6 12.35-3.09 25.51 2.31 36.72 1.51 3.14 3.54 6.06 4.54 9.39 1.82 6.1 0 12.67-2.42 18.58a109.52 109.52 0 0 1-12.78 23.2c-3 4.15-6.38 8.29-7.45 13.29-.72 3.35-.45 7.14-2.57 9.83-2.83 3.59-8.27 3.31-12.8 2.69-2.28-3.72 1.35-8.24 1.75-12.58.45-4.77-3.3-9.12-7.69-11s-9.34-2-14.13-2.12c-2-.07-4.15-.24-5.57-1.62a7.36 7.36 0 0 1-1.65-3.08 34.84 34.84 0 0 1-1.1-17.21c1.49-7.85 5.67-15.06 6.62-23 1.11-9.2-2.23-18.33-6.13-26.73S6 348.64 4.34 339.53s.23-19.55 7.39-25.43c3.91-3.21 9.1-4.86 12.27-8.8 4.29-5.33 3.71-13.37 7.92-18.76s12-6.5 18.85-7.14l14.49-1.33a45 45 0 0 1 9.55-.2c6.26.77 11.88 4.1 17.28 7.37 3.43 2.07 7.06 4.37 8.63 8.06a7.6 7.6 0 0 1-.36 6.56c-2.66 4.28-3.92.15-6 1.12-3.12 1.36-.79 11.71-2.46 16.04z",
    fill: "#965d7b"
  }));
};
UndrawWindowShopping.propTypes = {
  height: PropTypes.string,
  primaryColor: PropTypes.string
};
export default UndrawWindowShopping;